import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * Gerencia as requisições HTTP do sumário do equipamento.
 */
@Injectable({
    providedIn: "root"
})
export class SummaryHttpService {

    private readonly baseUrl: string;

    constructor(private readonly httpClient: HttpClient) {
        this.baseUrl = "/service/device"
    }

    getManagedDevice(deviceId: number): Observable<any> {
        return this.httpClient.get<any>(`${this.baseUrl}/${deviceId}`);
    }
}
